<template>
  <div>
    <v-app id="app">
      <Snackbar />
      <router-view style="min-height: 100vh" />
    </v-app>
  </div>
</template>
    <script>
import Snackbar from "@/components/AppSnackbar.vue";
export default {
  data() {
    return {};
  },
  components: {
    Snackbar,
  },
};
</script>
<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "General Sans", sans-serif !important;
  letter-spacing: 0px !important;
}
::placeholder {
  font-family: "General Sans", sans-serif !important;
}

.v-input input::placeholder {
  font-family: "General Sans", sans-serif !important;
}
.custom-font .v-input__control {
  font-family: "General Sans", sans-serif !important;
}
.custom-font input {
  font-family: "General Sans", sans-serif !important;
}
.v-input__control,
.v-input__control input {
  font-family: "General Sans", sans-serif !important;
}

.full-height {
  height: 100%;
}
.v-application {
  min-height: 100vh;
}
.v-input--is-focused .v-input__control .v-input__slot:after {
  background-color: rgb(102, 9, 255) !important; /* Custom focus color */
}

.v-text-field--solo .v-input__control .v-input__slot:after {
  background-color: rgb(102, 9, 255) !important;
}
</style>
